import { Icon, type IconName } from "./LandingIcons";

interface Capability {
  i: string;
  icon: IconName;
  title: string;
  desc: string;
}

const CAPS: Capability[] = [
  { i: "01", icon: "mic",    title: "Voice that actually does things",
    desc: "Real-time voice calls, streaming transcription, and tool-use in the same loop. Talk; it works." },
  { i: "02", icon: "spark",  title: "Spawn agents by describing them",
    desc: "Tell Omni what you need. It picks the model, wires the tools, writes the spec — and remembers it for next time." },
  { i: "03", icon: "memory", title: "One persistent memory",
    desc: "Facts, files, preferences, history — shared across every device. Search it, edit it, audit every write." },
  { i: "04", icon: "puzzle", title: "1,800+ skills & MCP servers",
    desc: "Drop-in integrations for Slack, GitHub, Sheets, Calendars, Notion. Or build your own with the SDK." },
  { i: "05", icon: "clock",  title: "Schedules, cron, automations",
    desc: "Recurring agents, conditional triggers, multi-step workflows — built in natural language, not YAML." },
  { i: "06", icon: "code",   title: "Build & ship your own",
    desc: "TypeScript SDK, remote IDE, hot-reload tooling. `omni publish` and you're live in the marketplace." },
];

export function CapabilitiesGrid() {
  return (
    <section id="platform" className="section section--sunk">
      <div className="container">
        <div className="section__head section__head--center">
          <div className="eyebrow eyebrow--accent">The platform</div>
          <h2 className="section__title">An operating layer for your work, not just a chat box.</h2>
          <p className="section__sub">
            Most AI tools end at the text bubble. Omni keeps going — into your tools, your memory, and your schedule.
          </p>
        </div>
        <div className="caps">
          {CAPS.map(c => (
            <div className="cap" key={c.i}>
              <div className="cap__num">{c.i}</div>
              <div className="cap__icon"><Icon name={c.icon} size={26} /></div>
              <h3 className="cap__title">{c.title}</h3>
              <p className="cap__desc">{c.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
